/*
HERO CAROUSEL like this, and then it
http://html.iwthemes.com/roker/run/index-one-page.html
Template
https://www.free-css.com/free-css-templates/page233/solution
*/
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// https://webthemez.com/preview/?fortune-business-bootstrap-html-website-template

import { appActions } from '../../reducers/app.reducer';
import { settingsActions } from '../../reducers/settings.reducer';
import Header from '../header/Header.react';
import ModalContainer from '../modal/ModalContainer.react';
import Routes from './routing/Routes.react';
import Notification from '../notification/Notification.react';
import Sidebar from '../sidebar/Sidebar.react';
import Hamburger from '../hamburger/Hamburger.react';
import Preload from './Preload.react';
var App = function App() {
  // Redux hooks
  var dispatch = useDispatch();
  var booted = useSelector(function (s) {
    return s.app.booted;
  });
  var isLoggedIn = useSelector(function (s) {
    return s.app.isLoggedIn;
  });

  // Action dispatchers
  var bootAction = function bootAction() {
    return dispatch(appActions.boot());
  };
  var getConstantsAction = function getConstantsAction() {
    return dispatch(settingsActions.getConstants());
  };
  useEffect(function () {
    bootAction();
  }, []);
  useEffect(function () {
    if (isLoggedIn) getConstantsAction();
  }, [booted, isLoggedIn]);
  return /*#__PURE__*/React.createElement("div", {
    className: "app",
    id: "app"
  }, /*#__PURE__*/React.createElement(Preload, null), /*#__PURE__*/React.createElement(Notification, null), booted && isLoggedIn && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Routes, null), /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement(ModalContainer, null), /*#__PURE__*/React.createElement(Sidebar, null), /*#__PURE__*/React.createElement(Hamburger, null)));
};
export default App;